import { getBooleanHashCode1bbj3u6b3v0a7 as getBooleanHashCode } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { Data_getInstance3v2yh00p6d130 as Data_getInstance } from './adapter/SavePinMutation_ResponseAdapter.mjs';
import {
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { SavePinMutation_VariablesAdapter_instance3b0rzxaga72ab as SavePinMutation_VariablesAdapter_instance } from './adapter/SavePinMutation_VariablesAdapter.mjs';
import { obj2vqjd1bjrpmyg as obj } from '../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/Adapters.mjs';
import { Mutationkenyz0l5btz as Mutation } from '../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/Mutation.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var DataClass;
function Data() {
  if (DataClass === VOID) {
    class $ {
      constructor(savePin) {
        this.d6h_1 = savePin;
      }
      toString() {
        return 'Data(savePin=' + this.d6h_1 + ')';
      }
      hashCode() {
        return this.d6h_1 == null ? 0 : getBooleanHashCode(this.d6h_1);
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof Data()))
          return false;
        if (!(this.d6h_1 == other.d6h_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'Data', VOID, VOID, VOID, VOID, VOID, {1: Data_getInstance});
    DataClass = $;
  }
  return DataClass;
}
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {
      constructor() {
        this.e6h_1 = '16ed341f62125adac6d4641ec718698f5efb684fe32af3e92d15f74176c9023c';
        this.f6h_1 = 'savePin';
      }
      a6f() {
        return 'mutation savePin($input: SavePinInput!) { savePin(input: $input) }';
      }
    }
    initMetadataForCompanion($);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance;
function Companion_getInstance() {
  return Companion_instance;
}
var SavePinMutationClass;
function SavePinMutation() {
  if (SavePinMutationClass === VOID) {
    class $ {
      constructor(input) {
        this.g6h_1 = input;
      }
      c6f() {
        return '16ed341f62125adac6d4641ec718698f5efb684fe32af3e92d15f74176c9023c';
      }
      operationId() {
        return this.c6f();
      }
      u47() {
        return Companion_instance.a6f();
      }
      d6f() {
        return 'savePin';
      }
      operationName() {
        return this.d6f();
      }
      o46(writer, customScalarAdapters, withDefaultValues) {
        SavePinMutation_VariablesAdapter_instance.h6h(writer, this, customScalarAdapters, withDefaultValues);
      }
      n46() {
        return obj(Data_getInstance());
      }
      toString() {
        return 'SavePinMutation(input=' + this.g6h_1.toString() + ')';
      }
      hashCode() {
        return this.g6h_1.hashCode();
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof SavePinMutation()))
          return false;
        if (!this.g6h_1.equals(other.g6h_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'SavePinMutation', VOID, VOID, [Mutation()]);
    SavePinMutationClass = $;
  }
  return SavePinMutationClass;
}
//region block: init
Companion_instance = new (Companion())();
//endregion
//region block: exports
export {
  Data as Datagefyj3dojvb5,
  SavePinMutation as SavePinMutation3865jhueq4vmv,
};
//endregion

//# sourceMappingURL=SavePinMutation.mjs.map
